import * as Yup from 'yup';


export const ForgotPasswordRecordSchema = Yup.object()
                                             .shape({
                                                        'username': Yup.string()
                                                                       .email()
                                                                       .required('email address is required field'),
                                                    });


export const ConfirmResetPasswordRecordSchema = Yup.object()
                                                   .shape({
                                                              'username': Yup.string()
                                                                             .email()
                                                                             .required('email address is required field'),
                                                              'confirmationCode': Yup.string()
                                                                                     .required('code is required field'),
                                                              'newPassword': Yup.string()
                                                                                .min(8, 'Minimum 8 chars')
                                                                                .required('password is required field'),
                                                          });


export const ChangePasswordRecordSchema = Yup.object()
                                             .shape({
                                                        'oldPassword': Yup.string()
                                                                          .required('current password is required'),
                                                        'newPassword': Yup.string()
                                                                          .min(8, 'Minimum 8 characters')
                                                                          .required('new password is required'),
                                                        'confirmPassword': Yup.string()
                                                                              .oneOf([Yup.ref('newPassword')], 'passwords must match')
                                                                              .required('please confirm your new password'),
                                                    });
